import React, {useState} from 'react';

function App(props) {

  var selectText = props.selectText;
  var inputsList = props.inputsList;

  const [openMenu, setOpenMenu] = useState(false);

  var dropDownClass = 'menu-item';
  if (openMenu){
    dropDownClass =  'menu-item open'
  }
  function clickOpenMenu(){
    setOpenMenu(!openMenu)
  }
  if (selectText === 'perc'){
    selectText = '%';
  }else if (selectText === 'dc'){
    selectText = '';
  }

  return <div className="menu">
            <li className={dropDownClass} onClick={clickOpenMenu}>&nbsp;&nbsp;{selectText} 
              <ul className='designDropDown'>
              {inputsList}
              </ul>
            </li>
            </div>  

}


//
export default App;
